import moment from "moment-timezone";
import { GMapsFormattedAddress, GMapsQueryLocation } from "../types/location";

const formatAddress = async (
  location: GMapsQueryLocation,
): Promise<{ destination: GMapsFormattedAddress }> => {
  const {
    address: [googleAddress],
  } = location;

  if (!googleAddress["address_components"]) throw new Error("Invalid input!");

  const address: GMapsFormattedAddress = {};

  const addressComponentsMap: { [key: string]: keyof GMapsFormattedAddress } = {
    country: "country",
    administrative_area_level_1: "state",
    locality: "city",
    sublocality: "colony",
    neighborhood: "neighborhood",
    route: "street",
    postal_code: "postcode",
    street_number: "exteriorNumber",
  };

  for (const component of googleAddress["address_components"]) {
    for (const type of component.types) {
      if (addressComponentsMap[type]) {
        (address as any)[addressComponentsMap[type]] = component["long_name"];
      }
    }
  }

  address.colony = address?.neighborhood ?? address.colony;
  delete address?.neighborhood;

  return {
    destination: {
      ...address,
      fullName: location.result,
      location: {
        type: "Point",
        coordinates: [location.lng, location.lat],
      },
    },
  };
};

function buildProductList(lineItems) {
  return lineItems?.flatMap((item) => [
    ...Array(item.qty).fill({
      name:
        item?.product?.product?.name +
        (item?.product?.title ? ` (${item?.product?.title})` : ""),
      productId: item?.product?.product?._id,
    }),
    ...(item.complements?.flatMap((complement) =>
      Array(complement.quantity).fill({
        name: `${complement.variant.title ? complement.variant.title : complement?.variant?.product?.name} (Complemento)`,
        productId: complement?._id,
      })) || []),
    ...(item.beverages?.flatMap((beverage) =>
      Array(beverage.quantity).fill({
        name: `${beverage.variant.title ? beverage.variant.title : beverage.variant.product?.name} (Bebida)`,
        productId: beverage?._id,
      })) || []),
    ...(item.extras?.flatMap((extra) =>
      Array(extra.quantity).fill({
        name: `${extra.variant.title ? extra.variant.title : extra.variant.product?.name} (Extra)`,
        productId: extra?._id,
      })) || []),
  ]);
}

const getFullWeekData = (start: moment.Moment, end: moment.Moment, data: any[]) => {
  const days: string[] = [];
  const orders: number[] = [];
  const revenue: number[] = [];

  const day = start.clone();
  while (day.isSameOrBefore(end, "day")) {
    const found = data.find(d => moment(d.date).isSame(day, "day"));
    days.push(day.format("DD/MM"));
    orders.push(found ? found.ordersCount : 0);
    revenue.push(found ? found.totalRevenue : 0);
    day.add(1, "day");
  }

  return {
    categories: days,
    orders,
    revenue,
  };
};

const formatCurrency = (value: string) => {
  return `$${parseFloat(value).toFixed(2)}`;
};

export { formatAddress, buildProductList, getFullWeekData, formatCurrency };
